import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScheduleValidation } from '@app/rostr/overview/dto/schedule-validation';
import { RostrFacade } from '@app/rostr/overview/facades/rostr.facade';
import { ValidationsFacade } from '@app/rostr/overview/facades/validations.facade';
import { getSeverityColor, getSeverityIcon } from '@shared/helpers/validations-helper';
import { Observable, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-required-shift-sidebar-widget',
  templateUrl: './required-shift-sidebar-widget.component.html',
  styleUrls: ['./required-shift-sidebar-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequiredShiftSidebarWidgetComponent implements OnInit, OnDestroy {
  routeSub: Subscription;
  validations$: Observable<ScheduleValidation[]>;

  public getSeverityColor = getSeverityColor;
  public getSeverityIcon = getSeverityIcon;

  // In every widget, constructors should not have complex dependencies as long
  // these would be loaded hierarchically from all modules that have widgets.
  // Copy this comment to every new widget
  constructor(
    private readonly rostrFacade: RostrFacade,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly validationsFacade: ValidationsFacade,
    private readonly route: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    this.routeSub = this.route.params.subscribe(paramMap => {
      const day = paramMap.day;
      this.validations$ = this.validationsFacade.getFilteredValidationsByDay$(day);
      this.changeDetector.markForCheck();
    });
  }

  public ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }

  public toggleValidation(validation: ScheduleValidation): void {
    this.rostrFacade.schedule$.pipe(first()).subscribe(schedule => {
      this.validationsFacade.toggleValidation(validation.checksum, schedule.id).pipe(first()).subscribe();
    });
  }
}
